
// export const BASE_URL = 'https://api.dreamerdesigns.com';
// export const BASE_URL = 'http://localhost:3001';
// export const BASE_URL = 'http://srv654577.hstgr.cloud:5001';
// export const BASE_URL = process.env.ENVIRONMENT === "test" ? "https://devapi.dreamerdesigns.com" : process.env.PROUCTION_BASE_URL
export const BASE_URL =  "https://devapi.dreamerdesigns.com"



export const API_URL = 'Och8289v5Aty5S2oUG9PUKhSy2geZh9r3Wum(lhfAREdwEZ*%ZOeyAOa7XsWuOxGWs8KeWHgF*UwEwRjjZzIFaWTVs8R0s5m%9';
console.log("baseurl: ", BASE_URL, API_URL)
export const GET_USERS = 'admin/getUsersList';
export const GET_PROJECTS = 'admin/getProjectsList';
export const LOGIN = 'admin/login';
export const GET_USER_DETAIL = 'admin/getUsersDetail';
export const GET_PROJECT_DETAIL = 'admin/getProjectsDetail';
export const UPDATE_USER_DETAIL = 'admin/updateUserDetail';
export const GET_GRAPH_DETAIL = 'admin/getGraphDetail';
export const EDIT_PROJECT = 'admin/editProject';
export const GET_LEADERBOARD = 'admin/getLeaderboard';
export const CREATE_COMPETITION = 'admin/createCompetition';
export const END_COMPETITION = 'admin/endCompetition';
export const VERIFY_PROJECT = 'admin/verifyProjectForLeaderboard';
export const GET_VERIFICATIONS_LIST = 'admin/getVerificationsList';
export const GET_PREVIOUS_LEADERBOARD = 'admin/getPreviousLeaderboard';
export const GET_PREVIOUS_LEADERBOARD_DATA = 'admin/getPreviousLeaderboardData';
export const EDIT_LEADERBOARD_DESCRIPTION = 'admin/editLeaderboardDescription';
export const DELETE_USER = 'admin/deleteUser';
export const DELETE_PROJECT = 'admin/deleteProject';
export const GET_STREAKS = 'admin/getStreaksMilestone';
export const GET_STREAK_MILESTONE_DETAILS = 'admin/getStreakMilestoneDetails';
export const ADD_STREAK_MILESTONE = 'admin/createStreakMilestone';
export const EDIT_STREAK_MILESTONE = 'admin/updateStreakMilestone';
export const DELETE_STREAK_MILESTONE = 'admin/deleteStreakMilestone';
export const GET_BADGES = 'admin/getBadges';
export const GET_BADGES_DEFINITIONS = 'admin/getBadgeDefinitions';
export const CREATE_BADGE_DEFINITION = 'admin/createBadgeDefinition';
export const UPDATE_BADGE_DEFINITION = 'admin/updateBadgeDefinition';
export const DELETE_BADGE_DEFINITION = 'admin/deleteBadgeDefinition';
export const GET_BADGE_DEFINITION_DETAILS = 'admin/getBadgeDefinitionDetails';
export const GET_LEVELS = 'admin/getLevels';
export const GET_LEVEL_DETAILS = 'admin/getLevelDetails';
export const CREATE_LEVEL = 'admin/createLevel';
export const DELETE_LEVEL = 'admin/deleteLevel';
export const DELETE_REWARD = 'admin/deleteRewardDefinition';
export const GET_TIERS = 'admin/getTiers';
export const GET_TIER_DETAILS = 'admin/getTierDetails';
export const CREATE_TIER = 'admin/createTier';
export const UPDATE_TIER = 'admin/updateTier';
export const DELETE_TIER = 'admin/deleteTier';
export const GET_CONFIGS = 'admin/getConfigs';
export const GET_CONFIG_DETAILS = 'admin/getConfigDetails';
export const CREATE_CONFIGS = 'admin/createConfig';
export const UPDATE_CONFIGS = 'admin/updateConfig';
export const DELETE_CONFIGS = 'admin/deleteConfig';
export const GET_STREAK_GLOBAL_SETTINGS = 'admin/getStreakGlobalSettings';
export const UPDATE_STREAK_GLOBAL_SETTINGS = 'admin/updateStreakGlobalSettings';
export const GET_USER_REWARDS = 'admin/getUserRewards';
export const ISSUE_USER_REWARD = 'admin/issueReward';
export const GET_REWARDS = 'admin/getRewardDefinitions';
export const CREATE_REWARD = 'admin/createRewardDefinition';
export const UPDATE_REWARD = 'admin/updateRewardDefinition';
export const GET_MILESTONE_REVIEW_REQUESTS = 'admin/getMilestoneReviewRequests';
export const REVIEW_MILESTONE_REQUESTS = 'admin/reviewMilestoneRequest';